import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Toast } from "primereact/toast";
import { Button } from 'primereact/button';
import { AutoComplete } from "primereact/autocomplete";
import Dokumenti from './Dokumenti';
import Odsustva from './Odsustva';
import CustomDropdown from '../../../../custom/customDropdown';

const ZaposleniDokumentiGO = () => {
  const { t } = useTranslation();
 

const auth = useContext(AuthContext);    
const company = useSelector(state => state.company)
const user = useSelector(state => state.user)
const toast = useRef(null);
const formRef = useRef(null);
const employee = useSelector(state => state.employee);
const dispatch = useDispatch();
const [poruka, setPoruka] = useState(null)   
const [employeeDB, setEmployeeDB] = useState(null) 
const [employeeVacationDB, setEmployeeVacationDB] = useState(null)     
const [vacationOptions, setVacationOptions] = useState(null)    
const [filesDB, setFilesDB] = useState(null)
/* Dokumenta zavedena kroz Administracija > Štampa dokumentacije — stoje uz
   upload-ovane fajlove da bi pregled po zaposlenom bio kompletan. */
const [zavedenaDB, setZavedenaDB] = useState([])
const [filteredEmployee, setfilteredEmployee] = useState([]);
const [izabran, setIzabran] = useState(false)
const [izabranVac, setIzabranVac] = useState(false)
const [idEmployee, setIdEmpolyee] = useState(null)
const [idForUpdate, setIdForUpdate]  = useState(null)
const [formSubmitted, setFormSubmitted] = useState(false);

  const [formDataVacation, setFormDataVacation] = useState({
        vacationType: null,
        vacationStart: null,
        vacationEnd: null,
    });
const removeDataGO = () => {
    setFormDataVacation({
        vacationType: null,
        vacationStart: null,
        vacationEnd: null,
    })
    setEmployeeVacationDB(null)
    setFilesDB(null)
    setZavedenaDB([])
}

const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDataVacation(prev => ({ ...prev, [name]: value }));
    };

useEffect(()=>{
    if(!formSubmitted){
         let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            }
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/employees", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                              
                                setEmployeeDB(parsedData.EmployeesDB)
                                setVacationOptions(parsedData.TipoviOdstustva)
                                if(employee){
                                     let checkEmp = parsedData.EmployeesDB.filter(x => x.value == employee)

                                if(checkEmp.length > 0){
                                    selectEmployeeFromDispatch()
                                    vratiDokumenta(checkEmp[0].value)
                                } else {
                                    dispatch({
                                    type: "EMPLOYEE",
                                    value: null});
                                    toast.current.show({
                                    severity: "info",
                                    summary: t('admin.m_obavestenje_1'),
                                    detail: t('admin.m_pasivan_zaposleni'),
                                    life: 3000,
                                });
                                }    
                                }
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                        }
    },[formSubmitted])

      const selectEmployeeFromDispatch = () => {
          
            if(employee !=null){
                setIdEmpolyee(employee)
                setIzabran(true)
                vratiOdmore(employee)
            } else {
                setIzabran(false)
            }
        }
    
       useEffect(()=>{
            if(employee == null){
            removeDataGO()
            }
       },[employee])

const formatDateForAPI = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const handleFormSubmit = (e) => {

            e.preventDefault(); // bitno da ne submituje bez validacije
                setFormSubmitted(true)
            if (formRef.current && !formRef.current.checkValidity()) {
                formRef.current.reportValidity(); // prikazuje native browser poruke
                return;
            }
    vacationInsertDB()
 }

const vacationInsertDB = async () => {
    
    if(!izabran) {
        setPoruka(<p class="infoPoruka">Zaposleni nije selektovan. Moguci unos tek nakon izbora zaposlenog.</p>)
    } else {
        
          if(idEmployee && formDataVacation.vacationType && formDataVacation.vacationStart){
            if(formDataVacation.vacationEnd <= formDataVacation.vacationStart) {
                setPoruka(<p class="infoPoruka">Nije moguće uneti odsustvo čiji je datum od veći ili jedan datuma do.</p>)
            } else if(formDataVacation.vacationEnd > new Date()){
                setPoruka(<p class="infoPoruka">Nije moguće uneti odsustvo čiji je datum do u budućnosti.</p>)
            }
            else {
                if(idForUpdate){
                     let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idForUpdate,
                                id_zaposleni: idEmployee,
                                firma_id: company.companyId,
                                user_id: user.userId,
                                vacationType: formDataVacation.vacationType,
                                vacationStart: formatDateForAPI(formDataVacation.vacationStart),
                                vacationEnd: formatDateForAPI(formDataVacation.vacationEnd),
                            }),
                        };
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/employeeRestUpdate", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
            
                            removeDataGO()
                            setPoruka(null);
                            setIzabran(false);
                            setFormSubmitted(false)    
                            let naziv = employeeDB.find(e=>e.value == idEmployee)
                            toast.current.show({
                                severity: "success",
                                summary: `Uspešna izmena odsustva za zaposlenog ${naziv.label}!`,
                                life: 3000,
                            });
                            setIdEmpolyee(null);
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                     let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id_zaposleni: idEmployee,
                                firma_id: company.companyId,
                                user_id: user.userId,
                                vacationType: formDataVacation.vacationType,
                                vacationStart: formatDateForAPI(formDataVacation.vacationStart),
                                vacationEnd: formatDateForAPI(formDataVacation.vacationEnd),
                            }),
                        };
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/employeeRestInsert", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                            
                            setFormSubmitted(false)
                            removeDataGO()
                            setPoruka(null);
                            setIzabran(false);
                            let naziv = employeeDB.find(e=>e.value == idEmployee)
                            toast.current.show({
                                severity: "success",
                                summary: `Uspešan unos odsustva za zaposlenog ${naziv.label}!`,
                                life: 3000,
                            });
                            setIdEmpolyee(null);
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                }
                       
            }
    } else {
        setPoruka(<p class="infoPoruka">Zaposleni je selektovan. Moguci unos tek nakon popunjavanje tipa i početak odsustva.</p>)
    }

    }
}
const vacationDeleteDB = async ()=>{
     if(idForUpdate){
       setFormSubmitted(true)
   
             let requestOptions = {
                            method: "DELETE",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idForUpdate,
                                id_zaposleni: idEmployee,
                                firma_id: company.companyId,
                                user_id: user.userId,
                            }),
                        };
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/employeeRestDelete", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                vratiOdmore(idEmployee)
                                setIzabranVac(false)
                                setIdForUpdate(null)
                                setFormSubmitted(false)
                                
                                toast.current.show({
                                severity: "success",
                                summary: `Uspešno obrisano odsustvo!`,
                                life: 3000,
                            });
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
    }
}

 const vratiDokumenta = async (employee)=>{
    if(employee){
      
   
             let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: employee,
                            }),
                        };
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/returnFiles", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                setFilesDB(data[0])
                            })
                            .then(() => vratiZavedena(employee))
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
    }
  }
/* Dokumenta generisana kroz Štampu dokumentacije (zavedena, sa RB) — idu u isti
   spisak kao i upload-ovani fajlovi, da pregled po zaposlenom bude kompletan. */
const vratiZavedena = async (idZaposlenog)=>{
    if(!idZaposlenog) { setZavedenaDB([]); return }
    try {
        const odgovor = await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/stampaDokumentacije", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token,
            },
            body: JSON.stringify({ step: "GET_ZAPOSLENI", id_zaposleni: idZaposlenog }),
        });
        const podaci = await odgovor.json();
        setZavedenaDB(Array.isArray(podaci) ? podaci : [])
    } catch (e) {
        setZavedenaDB([])
    }
}

const vratiOdmore = async (employee)=>{
    
             let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: employee,
                                firma_id: company.companyId,
                                user_id: user.userId,
                            }),
                        };
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/employeeRestGet", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                               
                                setPoruka(null)
                                setEmployeeVacationDB(data)
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
  }
const selectIdemployeeFUNC = (e) => {
        if(e.target.value == undefined) {
            setIzabran(false);
        } else {
            setIzabran(true);
            dispatch({
                                type: "EMPLOYEE",
                                value: e.target.value
                            });
            setIdEmpolyee(e.target.value);
            /* Uzima se izabrana vrednost, ne redux `employee` — dispatch iznad
               još nije stigao do store-a, pa je stara vrednost učitavala
               dokumenta prethodno izabranog zaposlenog (ili ništa pri prvom
               izboru). */
            vratiDokumenta(e.target.value);
            vratiOdmore(e.target.value);
            setPoruka(null);
            setFormDataVacation({
                vacationType: null,
                vacationStart: null,
                vacationEnd: null
            });
        }  
    };

  const prepareForUpdate = (id, type, start, end, reset) => {
    if(reset) {
        setIzabranVac(false)
         setFormDataVacation({
        vacationType: null,
        vacationStart: null,
        vacationEnd: null
    });
    setIzabranVac(false);
    setPoruka(null);
    return
    }
    const parseSerbianDate = (dateStr) => {
  const [day, month, year] = dateStr.split(".");
  return new Date(`${year}-${month}-${day}`);
};
    setIdForUpdate(id)
    setIzabranVac(true)
    setFormDataVacation({
    vacationType: type,
    vacationStart: parseSerbianDate(start),
    vacationEnd: parseSerbianDate(end)
    });
    setPoruka(<p class="infoPoruka">Odsustvo je selektovano. Mogužete izmeniti odsustvo ili ga obrisati.</p>)
  }

  
    const resetDispatchEmployee = () => {
          dispatch({
                            type: "EMPLOYEE",
                            value: null
                        });
    }

  const handleSelect = () => {
    if (idEmployee) {  // resetuj samo ako ima vrednost
        setIdEmpolyee(null)
        setIzabran(false)
        resetDispatchEmployee()
        removeDataGO()
    }
   
  }

  const invalidControl = (data) => {
  if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

  if (data && data != null && !Number(data)) {
    return data.length > 0 ? false : true;
  } else if (data != null && Number(data)) {
    return false;
  }
  return true;
};

return (
    <div className="p-fluid grid">
                <div className="col-12">
                    <Divider />
                       {!izabran && poruka ? poruka : null}
                       {izabran && poruka ? poruka : null}
                                      <div className="gridHeader">
                                                <h4>{t('finansije.izborZaposlenog')}:</h4>
                                          <CustomDropdown
                                                                                                         style={{ width: "20%", marginLeft: '1%' }}
                                                                                                         id="id_employee" 
                                                                                                         name="id_employee" 
                                                                                                         value={idEmployee} 
                                                                                                         required
                                                                                                         options={employeeDB || []}
                                                                                                         placeholder={t('finansije.izaberiZaposlenog')}
                                                                                                         optionLabel="label"
                                                                                                         onChange={selectIdemployeeFUNC}
                                                                                                         onFocus={handleSelect}
                                                                                                     />
                                                         
                                    </div>
                </div>
                <Toast ref={toast} />
                {/* Personal Data Section */}
                <div className="col-12 md:col-6">
                    <Card title={t('admin.m_odmori')}>
                        <form autoComplete="off" ref={formRef}>
                            <div className="gridDokumenti">
                                <div className="red1 redDokument">
                                    <div className="col-12 md:col-6">
                                    <label htmlFor="vacationType">{t('admin.tipOdsustva')}:</label>
                                    <Dropdown placeholder={t('admin.phTipOdsustva')} required invalid={invalidControl(formDataVacation.vacationType)} id="vacationType" name="vacationType" value={formDataVacation.vacationType} 
                                                            options={vacationOptions} onChange={handleChange}/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="vacationStart">{t('admin.odsustvoOd')}:</label>
                                    <Calendar id="vacationStart" name="vacationStart" required value={formDataVacation.vacationStart} invalid={invalidControl(formDataVacation.vacationStart)} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="vacationEnd">{t('admin.odsustvoDo')}:</label>
                                    <Calendar id="vacationEnd" name="vacationEnd" required value={formDataVacation.vacationEnd} invalid={invalidControl(formDataVacation.vacationEnd)} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                {izabranVac ? <div style={{ marginTop: "auto", flex: "0 0 10%" }}>
                                <Button label={t('common.delete')} className="mt-3 btn-danger" onClick={vacationDeleteDB}/>
                                </div>: null}
                                <div className="col-12">
                                <Button label={t('admin.sacuvaj')} className="mt-3" onClick={handleFormSubmit}/>
                                </div>
                                </div>
                            </div>
                        </form>
                    </Card>
                    <div id="odsustvaWorkspace">
                         <Card title={t('admin.m_pregled_odsustva')}>
                        <div className="gridDokumentiGO">
                            <div className="red1">
                                <div className="col-12 md:col-6">
                                {employeeVacationDB && <Odsustva employeeVacationDB={employeeVacationDB} setIzabranVac={setIzabranVac} prepareForUpdate={prepareForUpdate}/>}
                                </div>
                            </div>
                        </div>
                    </Card>
                     <Card title={t('admin.m_pregled_dokumenata')}>
                        <div className="gridDokumentiGO">
                            <div className="red1">
                                <div className="col-12 md:col-6">
                                {filesDB && <Dokumenti filesDB={filesDB} zavedenaDB={zavedenaDB}/>}
                                </div>
                            </div>
                        </div>
                    </Card>
                    </div>
                   
                </div>
                
             
            </div>
)
}

export default ZaposleniDokumentiGO;
